import { useAuth } from '@/context/AuthContext';
import { LoadingState, UnauthorizedState } from '@/components/states';
import { EmptyState } from '@/components/states';
import { ShieldAlert } from 'lucide-react';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { session, loading, isAdmin, profile } = useAuth();
  if (loading) return <LoadingState />;
  if (!session) return <UnauthorizedState />;
  if (adminOnly && profile && !isAdmin) {
    return <EmptyState icon={ShieldAlert} title="Accès réservé" description="Cette section est réservée aux administrateurs." />;
  }
  return children;
}
